<div>

<div class="modal-header">
  <button type="button" class="close close-lg pull-right" aria-label="Close"
          (click)="onCancel()" >
    <span aria-hidden="true">&times;</span>
  </button>
  <h3 id="myModalLabel">
    Appointment Log
    <span style="font-size: 12px;float: right; padding-right: 20px;" *ngIf="appointmentLog.appointment as appointment">
                Appointment time: <span style="color: #ccc;">{{appointmentTimeMs | amDateFormat: 'MM/DD/YYYY h:mm a' }}</span> &nbsp;&nbsp;
                Patient: <span style="color: #ccc;">{{appointment.firstName}} {{appointment.middleName}} {{appointment.lastName}}</span> &nbsp;&nbsp;
                Created: <span style="color: #ccc;">{{appointment.createdMs | amDateFormat: 'MM/DD/YYYY h:mm a'}}</span>
            </span>
  </h3>
</div>
<div class="modal-body">


  <div style="padding: 0px; display: flex">
    <!--div class="col-sm-6 col-md-6 col-lg-6" style="padding: 4px; align-items: stretch"-->
    <div class="col-sm-12 col-md-12 col-lg-12 clearfloat" style="width:99%; padding-bottom: 0px; min-height: 300px;">
        <p-tabView>
          <p-tabPanel header="Event Log">
            <ng-template pTemplate="content">
              <appointment-log-event-log
                  [appointmentId]="appointmentLog.appointment.appointmentId"
                  (selectedXmlIdList)="setXmlIdList($event)"
                  (selectedEventLog)="setEventLog($event)"
                  [selectedAppointment]="appointmentLog.appointment"
                  [selectedAppointmentDetail]="selectedAppointmentDetail"
                  [selectedTimeZone]="selectedTimeZone"></appointment-log-event-log>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel header="Appointment Detail">
            <ng-template pTemplate="content">
              <appointment-log-details [selectedAppointment]="appointmentLog.appointment"
                                       [selectedEventLog]="selectedEventLog"
                                       [loading]="logEventLoading"
                                       [eventsForSelectedMessage]="appointmentLog.selectedMessage"
                                       (selectAppointmentDetail) = "selectAppointmentDetail($event)"
                                       [selectedTimeZone]="selectedTimeZone"
              ></appointment-log-details>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
    </div>

  </div>
</div>

<div class="modal-footer">

    <div class="btn-group btn-toggle" style="padding-right: 16px">
      <button class="btn btn-lg"  style="font-size: 13px" (click)="toggleTimeZone()" [ngClass]="{ 'btn-default': !isUTC, 'btn-primary active': isUTC}">UTC</button>
      <button class="btn btn-lg" style="font-size: 13px" (click)="toggleTimeZone()" [ngClass]="{ 'btn-default': isUTC, 'btn-primary active': !isUTC}">{{appointmentLog.userTimeZone}}</button>
    </div>
  <button type="button" class="btn btn-default" (click)="onCancel()">Close</button>
</div>
</div>

